'use client'

import { useEffect } from 'react'

export default function WiseScripts() {
  useEffect(() => {
    let counterObserver = null

    // ----------------------------
    // FAQ Accordion
    // ----------------------------
    const accordionItems = document.getElementsByClassName('contentBX')
    for (let i = 0; i < accordionItems.length; i++) {
      accordionItems[i].onclick = null
      accordionItems[i].onclick = function () {
        for (let j = 0; j < accordionItems.length; j++) {
          if (accordionItems[j] !== this) accordionItems[j].classList.remove('active')
        }
        this.classList.toggle('active')
      }
    }

    // ----------------------------
    // Counter Animation
    // ----------------------------
    const counters = document.querySelectorAll('.counter')

    function animateCounter(counter) {
      const target = +(counter.getAttribute('data-target') || 0)
      let current = 0
      const duration = 2000
      const increment = Math.ceil(target / (duration / 16))

      function updateCounter() {
        current += increment
        if (current >= target) {
          counter.textContent = target.toLocaleString() + (target >= 100 ? '+' : '%')
        } else {
          counter.textContent = current.toLocaleString()
          requestAnimationFrame(updateCounter)
        }
      }

      updateCounter()
    }

    counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const counter = entry.target
          if (entry.isIntersecting) {
            if (!counter.classList.contains('counted')) {
              animateCounter(counter)
              counter.classList.add('counted')
            }
          } else {
            counter.classList.remove('counted')
            counter.textContent = '0'
          }
        })
      },
      { threshold: 0.5 }
    )

    counters.forEach((counter) => counterObserver.observe(counter))

    // ----------------------------
    // AOS init (if present)
    // ----------------------------
    if (window.AOS) {
      window.AOS.init({
        offset: 200,
        delay: 100,
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
      })
    }

    return () => {
      if (counterObserver) counterObserver.disconnect()
    }
  }, [])

  return null
}